import BrButton from '@govbr/react-components/lib/BrButton';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './TutorialExclusaoPorObito.module.css';
import { useAppSelector } from '../../../app/hooks';
import { selectMembrosFamiliares } from '../../ConsultaCompleta/consultaCompletaSlice';

const TutorialExclusaoPorObito: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const integrantesFamilia: any[] = useAppSelector(selectMembrosFamiliares);

  const concluir = () => {
    if (location.state?.readOnly) {
      // Se o usuário estiver abrindo o tutorial somente leitura, não redireciona para
      // exclusão por óbito.
      return history.goBack();
    }

    history.replace('/exclusaoPorObito');
  };

  const listaIntegrantesComObito = () => {
    const integrantesComObito = integrantesFamilia.filter(integrante => integrante.obito && !integrante.solicitacaoExclusaoObito);

    return integrantesComObito?.map((integrante, index) => {
      const isLastElement = index === integrantesComObito.length - 1;
      const comma = isLastElement ? '.' : ', ';

      return (
        <div key={index}><b>{integrante.pessoaDadosCadastroDTO.nomePessoa}</b>{comma}</div>
      );
    });
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.containerScrollable}>
          <div className={styles.titleWrapper}>
            <div className={styles.title}>
              Exclusão da pessoa falecida
            </div>
          </div>
          <div className={styles.content}>
            <div className={`${styles.text} ${styles.small}`}>
              {/**
               * TODO Mostrar nomes dos integrantes com óbito com a mensagem:
               * O Governo Federal identificou registro de falecimento para
               * NOME FULANO, NOME CICLANO, NOME BELTRANO.
               * */}
              O Governo Federal identificou registro de falecimento para: <p/> {listaIntegrantesComObito()}
            </div>
            <div className={`${styles.text} ${styles.small}`}>
              Aqui o Responsável Familiar poderá realizar a exclusão desta(s) pessoa(s).
            </div>
            <div className={styles.footerWrapper}>
              <div className={styles.botaoWrapper}>
                <BrButton className={styles.botao} onClick={() => concluir()}>
                  Concluir
                </BrButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TutorialExclusaoPorObito;
